// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  display: inline-block;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  line-height: 1.7;
  width: 80px;
  text-transform: none;
  box-sizing: border-box;
}

.badge-done {
  background-color: #008567;
}

.badge-critical {
  background-color: #eb0000;
}

.badge-highest {
  background-color: #eb0000;
}

.badge-high {
  background-color: #ff4747;
}

.badge-moderate {
  background-color: #ffd633;
}

.badge-low {
  background-color: #008567;
}

.badge-lowest {
  background-color: #00ab84;
}

.badge-planning {
  background-color: #999cac;
}

.badge-medium {
  background-color: #ffd633;
}

.badge-no-sla {
  background-color: #9e9e9e;
}

.badge-undefined {
  background-color: #616161;
}

.badge-default {
  background-color: #bdbdbd;
}

.badge-status-to-do {
  color: #6666cc;
}

.badge-status-to-do-dot {
  background-color: #6666cc;
}

.badge-status-open {
  color: #008567;
}

.badge-status-open-dot {
  background-color: #008567;
}

.badge-status-done {
  color: #eb0000;
}

.badge-status-done-dot {
  background-color: #eb0000;
}

.badge-status-new {
  color: #db7e0c;
}

.badge-status-new-dot {
  background-color: #db7e0c;
}

.badge-status-in-progress {
  color: #b38f00;
}

.badge-status-in-progress-dot {
  background-color: #b38f00;
}

.badge-status-closed {
  color: #eb0000;
}

.badge-status-closed-dot {
  background-color: #eb0000;
}

.badge-status-on-hold {
  color: #1e88e5;
}

.badge-status-on-hold-dot {
  background-color: #1e88e5;
}

.badge-status-resolved {
  color: #8e24aa;
}

.badge-status-resolved-dot {
  background-color: #8e24aa;
}

.badge-status-cancelled {
  color: #999CAC;
}

.badge-status-cancelled-dot {
  background-color: #999CAC;
}

.status-wrapper {
  display: flex;
  align-items: center;
  font-size: 14px;
  text-transform: capitalize;
  gap: 8px;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/badge-renderer/badge-renderer.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AACA;EACI,yBAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AAAA;EACI,yBAAA;AAGJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AAYI;EACI,cAdQ;AAKhB;;AAYI;EACI,yBAlBQ;AAShB;;AAII;EACI,cAdQ;AAahB;;AAII;EACI,yBAlBQ;AAiBhB;;AAJI;EACI,cAdQ;AAqBhB;;AAJI;EACI,yBAlBQ;AAyBhB;;AAZI;EACI,cAdQ;AA6BhB;;AAZI;EACI,yBAlBQ;AAiChB;;AApBI;EACI,cAdQ;AAqChB;;AApBI;EACI,yBAlBQ;AAyChB;;AA5BI;EACI,cAdQ;AA6ChB;;AA5BI;EACI,yBAlBQ;AAiDhB;;AApCI;EACI,cAdQ;AAqDhB;;AApCI;EACI,yBAlBQ;AAyDhB;;AA5CI;EACI,cAdQ;AA6DhB;;AA5CI;EACI,yBAlBQ;AAiEhB;;AApDI;EACI,cAdQ;AAqEhB;;AApDI;EACI,yBAlBQ;AAyEhB;;AAnDA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,QAAA;AAsDJ;;AAnDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAsDJ","sourcesContent":[".badge {\n    display: inline-block;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #ffffff;\n    text-align: center;\n    line-height: 1.7;\n    width: 80px;\n    text-transform: none;\n    box-sizing: border-box;\n}\n\n.badge-done {\n    background-color: #008567;\n}\n\n.badge-critical {\n    background-color: #eb0000;\n}\n.badge-highest {\n    background-color: #eb0000;\n}\n.badge-high {\n    background-color: #ff4747;\n}\n\n.badge-moderate {\n    background-color: #ffd633;\n}\n\n.badge-low {\n    background-color: #008567;\n}\n.badge-lowest {\n    background-color: #00ab84;\n}\n\n.badge-planning {\n    background-color: #999cac;\n}\n\n.badge-medium {\n    background-color: #ffd633;\n}\n\n.badge-no-sla {\n    background-color: #9e9e9e;\n}\n\n.badge-undefined {\n    background-color: #616161;\n}\n\n.badge-default {\n    background-color: #bdbdbd;\n}\n\n$status-colors: (\n    'to-do': #6666cc,\n    'open':  #008567,\n    'done': #eb0000,\n    'new': #db7e0c,\n    'in-progress': #b38f00,\n    'closed': #eb0000,\n    'on-hold': #1e88e5,\n    'resolved': #8e24aa,\n    'cancelled': #999CAC,\n);\n\n@each $status, $color in $status-colors {\n    .badge-status-#{$status} {\n        color: $color;\n    }\n\n    .badge-status-#{$status}-dot {\n        background-color: $color;\n    }\n}\n\n.status-wrapper {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    text-transform: capitalize;\n    gap: 8px;\n}\n\n.status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
